<app-module-header [title]="organization.organizationName + ' - ' + 'Bommar'" icon="garage_home"></app-module-header>

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="dashboard-container">
  <div class="filter-group multiple-select">
    <label class="filter-label">{{ 'PARKING_PRICING.PARKINGS' | transloco }}</label>
    <mat-form-field>
      <mat-select [placeholder]="'PARKING_PRICING.PARKINGS' | transloco" [(value)]="selectedParkings" multiple
        (selectionChange)="filterGates()" [disabled]="loading">
        @for (parking of parkings; track parking) {
          <mat-option [value]="parking.value">
            {{ parking.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (cameras?.length > 0) {
    <div class="camera-grid">
      @for (cam of filteredCameras; track cam) {
        <div class="camera-card">
          <div class="header">
            <div class="d-flex align-items-center w-100">
              <mat-icon>meeting_room</mat-icon>
              <div class="d-flex align-items-center flex-wrap">
                <span class="ms-2">{{ cam.description }}</span>
                <span class="ms-2">[ {{ getGateType(cam.gateType) }} ]</span>
              </div>
            </div>
          </div>
          <div class="gate-actions d-flex align-items-center justify-content-end  flex-wrap w-100">
            @if (cam.gateType === 'Checkin' && cam.allowDriveUp) {
              <button mat-raised-button color="accent"
                class="me-auto qr-button" (click)="showDriveUpQRCode(cam)">
                <mat-icon class="qr-icon">qr_code_2</mat-icon>
                <span>{{ 'SHOW_DRIVE_UP_QR.TITLE' | transloco }}</span>
              </button>
            }
            @if (cam.mode) {
              <mat-form-field appearance="outline" class="compact-select">
                <mat-select placeholder="Mode" [(value)]="cam.mode" (selectionChange)="setGateMode(cam, $event.value)"
                  panelClass="compact-panel">
                  @for (mode of gateModes; track mode) {
                    <mat-option [value]="mode.value" class="compact-option">
                      {{ mode.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <div class="d-flex align-items-center">
              <button mat-raised-button variant="tonal" color="primary" class="ms-2" (click)="openGateForm(cam)">
                <mat-icon>garage</mat-icon>
                <span> {{ 'OPEN_GATE.TITLE' | transloco }} </span>
              </button>
              <button mat-icon-button (click)="startStream(cam.camId)">
                <mat-icon>refresh</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="stopStream(cam.camId)">
                <mat-icon>stop</mat-icon>
              </button>
              <button mat-icon-button class="fullscreen-btn" (click)="enlargeVideo(videoPlayer)">
                <mat-icon>fullscreen</mat-icon>
              </button>
            </div>
          </div>
          <div class="video-container">
            <video #videoPlayer [id]="cam.camId" class="video-player" width="100%" height="auto"
              poster="/assets/img/placeholder.jpg">
              Your browser does not support the video tag.
            </video>
            @if (!cameraStates[cam.camId]) {
              <div (click)="startStream(cam.camId)" class="video-placeholder">
                <div class="placeholder-content">
                  <mat-icon class="placeholder-icon">videocam_off</mat-icon>
                  <p>Click to start stream</p>
                </div>
              </div>
            }
          </div>
          @if (cam.displays && cam.displays.length > 0) {
            <div class="display-container">
              @for (display of cam.displays; track display) {
                <div class="d-flex flex-row align-items-center justify-content-between">
                  @if (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) || myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId))) {
              <a [href]="parkingDisplay + '?id='+display.id" target="_blank">
                <mat-icon>connected_tv</mat-icon>
                <span>
                  {{ display.name ? display.name : display.id }}
                </span>
              </a>
              <button mat-button mat-stroked-button color="primary"
                (click)="openDisplayTests(cam.id, display)">Test</button>
            
} @else {

              <a class="display-link-disabled">
                <mat-icon>connected_tv</mat-icon>
                <span>
                  {{ display.name ? display.name : display.id }}
                </span>
              </a>
            
}
            
          </div>
}
        </div>
}

      </div>
}
    </div>
  
} @else {

    <div class="empty-state">
      <mat-icon class="empty-icon">garage</mat-icon>
      <p class="empty-message">No gates configured</p>
    </div>
  
}

  
</div>